import { render, staticRenderFns } from "./TerminalReadOnly.vue?vue&type=template&id=72886be5&scoped=true&"
import script from "./TerminalReadOnly.vue?vue&type=script&lang=js&"
export * from "./TerminalReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./TerminalReadOnly.vue?vue&type=style&index=0&id=72886be5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72886be5",
  null
  
)

export default component.exports